'use strict';

angular.module('shiftTraderApp')
    .directive('saAvailabilityBar', function () {
      return {
        templateUrl: 'views/directives/saAvailabilityBar.html',
        restrict: 'EA',
        scope: {
          dayAvailabilityRules:'=saAvailabilityBar',
          dayNum: '=',
          rawDates:'=',
          editable:'@',
          onChange:'=',
          me:'=',
          fullDayLabel: '@',
          showLabel: '@',
          eventIdentifier: '@'
        },
        controller: ['$scope','TimeService', 'flash',function($scope, TimeService, flash) {
          var calculateTimeOverlay = function() {
            $scope.currentStartDateTwix = TimeService.getDayTwixFromDate($scope.rawDates.start_time);
            $scope.currentEndDateTwix = TimeService.getDayTwixFromDate($scope.rawDates.end_time);
            if ($scope.currentStartDateTwix.equals($scope.currentEndDateTwix) || $scope.rawDates.end_time.hour() === 0) {
              // can deduce that it doesn't go into the next day, so the width can just be distance between start and end
              $scope.shift = {
                styling: {
                  left: ($scope.rawDates.start_time.hours() * 60 + $scope.rawDates.start_time.minutes()) / 1440.0 * 100 + '%',
                  width: ($scope.rawDates.start_time.twix($scope.rawDates.end_time).length('minutes') / 1440.0 * 100) + '%',
                  top: -1,
                  height: 22
                }
              };
            } else {
              if ($scope.dayNum === 0) {
                $scope.shift = {
                  styling: {
                    left: ($scope.rawDates.start_time.hours() * 60 + $scope.rawDates.start_time.minutes()) / 1440.0 * 100 + '%',
                    width: ($scope.rawDates.start_time.twix($scope.currentEndDateTwix.start).length('minutes') / 1440.0 * 100) + '%',
                    top: -1,
                    height: 22
                  }
                };
              } else {
                $scope.shift = {
                  styling: {
                    left: '0%',
                    width: ($scope.currentEndDateTwix.start.twix($scope.rawDates.end_time).length('minutes') / 1440.0 * 100) + '%',
                    top: -1,
                    height: 22
                  }
                };
              }
            }

            $scope.shift.styling['z-index'] = 10;
          };

          if (!_.isUndefined($scope.rawDates)) {
            if (_.has($scope.rawDates, 'watch') && $scope.rawDates.watch) {
              $scope.$watch('[rawDates.start_time._d, rawDates.end_time._d]', function() {
                calculateTimeOverlay();
              }, true);
            } else {
              calculateTimeOverlay();
            }
          }
        }],
        link: function postLink(scope, element) {
          scope.useFullDayLabels = (scope.fullDayLabel === 'true' || scope.fullDayLabel === true);
          scope.showTheLabel = (scope.showLabel !== 'false' && scope.showLabel !== false);
          scope.isEditable = (scope.editable === 'true' || scope.editable === true);

          if (scope.showTheLabel) {
            if (scope.useFullDayLabels) {
              $(element).find('.availability_bar').addClass('full_day_labels');
            } else {
              $(element).find('.availability_bar').addClass('short_day_labels');
            }
          }
        }
      };
    });
